// InlineAlert — compact contextual notice for inside cards/forms.
// Smaller than Banner; no dismiss control by default.

const TINTS = {
  info:     { color: 'var(--olv-cyan)',  bg: 'rgba(0,212,255,0.05)',  border: 'rgba(0,212,255,0.18)' },
  success:  { color: 'var(--olv-green)', bg: 'rgba(0,230,138,0.05)',  border: 'rgba(0,230,138,0.18)' },
  warning:  { color: 'var(--olv-amber)', bg: 'rgba(255,178,36,0.05)', border: 'rgba(255,178,36,0.18)' },
  critical: { color: 'var(--olv-red)',   bg: 'rgba(255,59,92,0.05)',  border: 'rgba(255,59,92,0.20)' },
}

export default function InlineAlert({ severity = 'info', children }) {
  const t = TINTS[severity] || TINTS.info
  return (
    <div
      role="alert"
      style={{
        background: t.bg,
        border: `1px solid ${t.border}`,
        borderRadius: 'var(--olv-radius-card)',
        padding: '8px 12px',
        fontSize: 11,
        color: t.color,
        fontFamily: 'var(--font-mono)',
        lineHeight: 1.5,
      }}
    >
      {children}
    </div>
  )
}
